// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1_Hsi","checkboxCol":"Table_checkboxCol__1zThj","emailCol":"Table_emailCol__2ry00","actionCol":"Table_actionCol__Z-_Zc"};